export default __webpack_public_path__ + "static/media/edit_button.028487f7.svg";